import React from 'react';
import {Horizontal, PlusIcon, Vertical} from '@taopix/taopix-design-system';
import AddPagesButton from '../Page/Actions/AddPagesButton';
import {useSelector} from 'react-redux';
import {LayoutSelector} from '../../Selectors';
import {useTranslation} from 'react-i18next';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';

const AddPrintsButton = () => {
  const {t} = useTranslation();
  const ui = useUiState();
  const layout = useSelector(LayoutSelector);

  return (
    <>
      {ui.state.zoomLevel === 100 && (
        <AddPagesButton
          buttonProps={{
            size: ui.state.isSmallScreen ? 'medium' : 'small',
            buttonStyle: 'standard',
            startIcon: <PlusIcon />,
            label: t('*:str_TitleAddMorePrints'),
          }}
          pageNumber={layout.lastpagenumber}
          pageType="print"
          popoutProps={
            ui.state.isSmallScreen
              ? undefined
              : {
                  anchorOrigin: {horizontal: Horizontal.Centre, vertical: Vertical.Bottom},
                  transformOrigin: {horizontal: Horizontal.Centre, vertical: Vertical.Top},
                  offset: {x: 0, y: 10},
                }
          }
        />
      )}
    </>
  );
};

export default AddPrintsButton;
